import { getData, URLs } from '@common/api';
import * as Section from '@common/models/sections';
import { call, ForkEffect, put, takeEvery } from 'redux-saga/effects';

import { fetchAboutFailure, fetchAboutRequest, fetchAboutSuccess } from './slice';

function* fetchAboutSaga() {
  try {
    const { data } = yield call(() => getData({ url: URLs.GET_ABOUT }));
    data.sections = Section.processResponse(data.sections);
    yield put(fetchAboutSuccess(data.sections));
  } catch (e) {
    yield put(fetchAboutFailure('Request failed with: ' + e));
  }
}

export default function* aboutSagas(): Generator<ForkEffect<never>, void, unknown> {
  yield takeEvery(fetchAboutRequest.type, fetchAboutSaga);
}
